import React, { ReactNode, useEffect, useRef } from 'react';
import cls from 'classnames';

import styles from './index.module.sass';

interface TetheredModalProps {
  children: ReactNode;
  className?: string;
  tether: ReactNode;
}

export const TetheredModal = ({ children, className, tether }: TetheredModalProps ) => {
  const modalRef = useRef<HTMLDivElement>();
  const tetherRef = useRef<HTMLSpanElement>();

  useEffect(() => {
    const positionModal = () => {
      const tetherElement = tetherRef.current;
      const modalElement = modalRef.current;

      if ( tetherElement && modalElement ) {
        const tetherRectangle = tetherElement.getBoundingClientRect();
        const modalRectangle = modalElement.getBoundingClientRect();

        const tetherCenter = tetherRectangle.left + tetherRectangle.width / 2;
        const centeredModalLeft = tetherCenter - modalRectangle.width / 2;
        const centeredModalRight = tetherCenter + modalRectangle.width / 2;
        const pageSidePadding = 15;

        // TODO: On mobile these conditions are not met when they should (use devices)
        if ( centeredModalLeft < pageSidePadding ) {
          modalElement.style.left = `${
            tetherRectangle.width / 2 + ( pageSidePadding - centeredModalLeft )
          }px`;
        } else if ( centeredModalRight > window.innerWidth - pageSidePadding ) {
          modalElement.style.left = `${
            tetherRectangle.width / 2 - ( centeredModalRight - ( window.innerWidth - pageSidePadding ))
          }px`;
        } else {
          modalElement.style.removeProperty( 'left' );
        }
      }
    };

    positionModal();
    window.addEventListener( 'resize', positionModal );
    return () => {
      window.removeEventListener( 'resize', positionModal );
    };
  }, []);

  return (
    <span className={cls( 'position-relative', className )}>
      <span className={`${styles.tether} position-relative text-nowrap`} ref={tetherRef}>
        {tether}
        <div className={`${styles.pointer} position-absolute mx-auto overflow-hidden`} />
      </span>

      <aside
        className={`${styles.modal} position-absolute pt-4 px-4 pb-1 rounded mt-3 bg-white`}
        ref={modalRef}
      >
        <div className={styles.content}>{children}</div>
      </aside>
    </span>
  );
};
